import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "kanban-sidebar-collapsed"

export default class extends Controller {
  static targets = ["panel", "backdrop", "label", "toggle", "main"]
  static classes = ["collapsed", "expanded"]

  connect() {
    this.collapsed = localStorage.getItem(STORAGE_KEY) === "true"
    this.applyState(false)
    this.handleResize = this.handleResize.bind(this)
    this.handleKeydown = this.handleKeydown.bind(this)
    window.addEventListener("resize", this.handleResize)
    document.addEventListener("keydown", this.handleKeydown)
  }

  disconnect() {
    window.removeEventListener("resize", this.handleResize)
    document.removeEventListener("keydown", this.handleKeydown)
    document.body.style.overflow = ""
  }

  handleKeydown(event) {
    if ((event.metaKey || event.ctrlKey) && event.key === "\\") {
      event.preventDefault()
      this.toggleCollapse()
    }
  }

  toggleCollapse() {
    if (window.innerWidth < 1024) return
    this.collapsed = !this.collapsed
    localStorage.setItem(STORAGE_KEY, this.collapsed)
    this.applyState(true)
  }

  toggleMobile() {
    const isOpen = !this.panelTarget.classList.contains("-translate-x-full")
    this.panelTarget.classList.toggle("-translate-x-full")

    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.toggle("hidden")
    }

    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", (!isOpen).toString())
    }

    document.body.style.overflow = isOpen ? "" : "hidden"
  }

  closeMobile() {
    this.panelTarget.classList.add("-translate-x-full")

    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.add("hidden")
    }

    document.body.style.overflow = ""

    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", "false")
    }
  }

  applyState(animate) {
    const root = document.documentElement

    if (this.collapsed && window.innerWidth >= 1024) {
      this.element.dataset.collapsed = "true"
      root.style.setProperty("--kanban-sidebar-width", "3.5rem")
      this.labelTargets.forEach((el) => el.classList.add("sr-only"))
    } else {
      this.element.dataset.collapsed = "false"
      root.style.setProperty("--kanban-sidebar-width", "13rem")
      this.labelTargets.forEach((el) => el.classList.remove("sr-only"))
    }

    if (animate) {
      this.panelTarget.classList.add("kanban-sidebar-transition")
      setTimeout(() => this.panelTarget.classList.remove("kanban-sidebar-transition"), 300)
    }
  }

  handleResize() {
    if (window.innerWidth >= 1024) {
      this.closeMobile()
      this.applyState(false)
    } else {
      document.documentElement.style.setProperty("--kanban-sidebar-width", "0px")
    }
  }
}
